import { Action } from './base/action.model';

export enum AppActionNames {
  STORE_INFO_USER = '[APP] Store Info User', 
  STORE_RESOURCE = '[APP] Store Resource', 
  STORE_SOURCE_INFO = '[APP] Store SourceInfo', 
  GET_INFO_USER = '[APP] Get Info User',
  GET_ISSUERS = '[APP] Get Issuers',
  GET_PRODUCTS = '[APP] Get Products',
  GET_THIRDAPP = '[APP] Get ThirdApp',
}
export class StoreResource implements Action {
  static readonly type = AppActionNames.STORE_RESOURCE;
  constructor() {}
}
export class StoreSourceInfos implements Action {
  static readonly type = AppActionNames.STORE_SOURCE_INFO;
  constructor(public payload: any) {}
}
export class StoreInfoUser implements Action {
  static readonly type = AppActionNames.STORE_INFO_USER;
  constructor(public payload: any) {}
}
export class GetInfoUser implements Action {
  static readonly type = AppActionNames.GET_INFO_USER;
  constructor() {}
}

export class GetIssuers implements Action {
  static readonly type = AppActionNames.GET_ISSUERS;
  constructor() {}
}
export class GetProducts implements Action {
  static readonly type = AppActionNames.GET_PRODUCTS;
  constructor() {}
}
export class GetThirdApps implements Action {
  static readonly type = AppActionNames.GET_THIRDAPP;
  constructor() {}
}